module.exports = __webpack_public_path__ + "d1042cb07e27036fa71dde95e3728bcf.svg";